<script lang="ts">
  import { Episodios, type Episodio } from '../../../lib/api';

  let {
    limit = 8,
    tipo = 'CONSULTA_EXTERNA' as Episodio['tipo'],
    onNavigate,
  }: {
    limit?: number;
    tipo?: Episodio['tipo'];
    onNavigate?: (tab: string) => void;
  } = $props();

  let items = $state<Episodio[]>([]);
  let error = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      items = (await Episodios.abiertos(tipo)).slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 45000); return () => clearInterval(t); });
</script>

<div class="panel">
  <header><h3>Episodios abiertos</h3><button type="button" onclick={cargar}>↻</button></header>
  {#if error}<p class="err">{error}</p>{/if}
  {#if items.length === 0 && !error}
    <p class="empty">Sin episodios abiertos.</p>
  {:else}
    <ul>
      {#each items as ep (ep.id)}
        <li>
          <div>
            <strong>{ep.numero ?? ep.id?.slice(0, 8)}</strong>
            <span>{ep.motivo ?? ep.pacienteId.slice(0, 8)}</span>
          </div>
          {#if onNavigate}
            <button type="button" class="link" onclick={() => onNavigate('episodios')}>Ver</button>
          {/if}
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .panel { border: 1px solid var(--glass-border); border-radius: var(--radius-xl); background: var(--glass-bg-card); backdrop-filter: var(--glass-blur); -webkit-backdrop-filter: var(--glass-blur); box-shadow: var(--glass-shadow); overflow: hidden; height: 100%; }
  header { display: flex; justify-content: space-between; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--glass-border); background: rgba(255,255,255,0.35); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); }
  h3 { margin: 0; font-size: 0.88rem; font-weight: 700; }
  header button { border: 1px solid var(--glass-border); background: var(--glass-bg-card); border-radius: 999px; cursor: pointer; padding: 0.2rem 0.55rem; font-weight: 600; transition: all 0.2s; }
  header button:hover { background: var(--brand-surface); border-color: var(--brand-strong); color: var(--brand-deep); }
  ul { list-style: none; margin: 0; padding: 0; max-height: 280px; overflow: auto; }
  li { display: flex; justify-content: space-between; align-items: center; padding: 0.6rem 0.85rem; border-bottom: 1px solid var(--glass-border); transition: background 0.15s; }
  li:hover { background: rgba(255,255,255,0.35); }
  strong { display: block; font-size: 0.85rem; }
  span { font-size: 0.78rem; color: var(--text-secondary); }
  .link { border: 0; background: transparent; color: var(--brand-strong); font-size: 0.78rem; cursor: pointer; font-weight: 600; }
  .empty, .err { padding: 0.85rem; font-size: 0.85rem; margin: 0; }
  .err { color: var(--danger); }
</style>
